import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let date = useDataValue({
    context: 'calendar_day',
    viewPath: props.viewPath,
    path: 'date',
  })

  return function onClick(e) {
    e.preventDefault()
    if (e.type === 'click') {
      submit({
        type: 'setDate',
        date,
      })

      if (typeof props.onLeftClick === 'function') props.onLeftClick(e)
    }
  }
}
